function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 5c0 1.66-1.34 3-3 3S9 6.66 9 5s1.34-3 3-3 3 1.34 3 3zM3 8c3.48 0 6.64 1.35 9 3.55C14.36 9.35 17.52 8 21 8v11c-3.48 0-6.64 1.36-9 3.55C9.64 20.35 6.48 19 3 19V8z",
  fill: "#666"
})));